module.exports = __webpack_public_path__ + "static/media/39.3815f9f9.jpg";